
import { RevIllustration } from '@ds/components/Illustration'
import { RevLink } from '@ds/components/Link'
import { RevModal } from '@ds/components/Modal'
import { IconCheckInCircle } from '@ds/icons/IconCheckInCircle'
import { IconRefund } from '@ds/icons/IconRefund'
import { IconTools } from '@ds/icons/IconTools'

import { MODAL_NAMES } from '@config/constants'
import { ROUTES } from '@router'

import ContentRow from '../ContentRow'

import translations from './VerifiedRefurbishedModal.translations'

export default {
  components: {
    ContentRow,
    IconCheckInCircle,
    IconTools,
    IconRefund,
    RevModal,
    RevLink,
    RevIllustration,
  },

  computed: {
    modalName: () => MODAL_NAMES.PRODUCT.VERIFIED_REFURBISHED,
    translations: () => translations,

    link() {
      return {
        name: ROUTES.CMS.ARTICLE,
        params: {
          pageName: 'impact-of-refurbished-on-environment',
          category: 'news',
        },
      }
    },
  },
}
